import React from "react";
//#region types
import { InvoicePaymentSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import {
  ReadOnlyVerticalFormField,
  TextDisplay,
  DateDisplay,
  NumberDisplay,
  GroupSectionInline,
  CurrencyDisplay,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoicePaymentDetailSection: React.FC<InvoicePaymentSectionProps> = (props) => {
  const { invoice, values } = props;

  return (
    <GroupSectionInline
      key={`invoice-section-paymentDetails`}
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentDetails)}
      icon={IconDefinitionConstants.WTransactions}
    >
      {!!values.paymentMethod && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.paymentMethod}
            label={TranslationKeys.Common.Payment}
          />
        </Grid>
      )}
      {!!values.bg && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.bg}
            label={TranslationKeys.Common.Bankgiro}
          />
        </Grid>
      )}
      {!!values.ocr && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.ocr}
            label={TranslationKeys.Common.OCRInvoiceNum}
            mainLabelGridSize={6}
          />
        </Grid>
      )}
      {!!values.paymentDate && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={DateDisplay}
            value={values.paymentDate}
            label={TranslationKeys.Common.PaymentDate}
            hideMainLabel={invoice.invoicePaymentMethod}
          />
        </Grid>
      )}
      <Grid item xs={6}>
        <ReadOnlyVerticalFormField
          Component={NumberDisplay}
          value={values.paymentTerms}
          label={TranslationKeys.Common.PaymentTerms}
        />
      </Grid>
      {!!values.paymentStatus && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.paymentStatus}
            label={TranslationKeys.Common.PaymentStatus}
          />
        </Grid>
      )}
      {values.leftToPay !== undefined && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={CurrencyDisplay}
            value={values.leftToPay}
            currency={values.currency}
            label={TranslationKeys.Common.Unpaid}
          />
        </Grid>
      )}
    </GroupSectionInline>
  );
};

export default InvoicePaymentDetailSection;
